<button
  class="avatar-uploader"
  [class.avatar-uploader--size-60]="size() === 60"
  [class.avatar-uploader--img-present]="!!src()"
  [disabled]="disabled()"
>
  <div class="avatar-uploader__backdrop"></div>

  <div class="avatar-uploader__icon">
    @if (loading()) {
      <fr8bot-ui-loading
        [delayMs]="0"
        [width]="size() === 80 ? 32 : 20"
        [height]="size() === 80 ? 32 : 20"
      />
    } @else {
      <fr8bot-ui-icon
        [name]="size() === 80 ? 'photo-camera-32' : 'photo-camera-20'"
        [size]="size() === 80 ? 32 : 20"
      />
    }
  </div>

  @if (!!src() && !loading()) {
    <fr8bot-ui-image class="avatar-uploader__img" [src]="src()" alt="avatar" [size]="size()" />
  }
</button>
